import { Skeleton, SxProps } from '@mui/material';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { forwardRef, ReactElement, ReactNode, Ref } from 'react';

interface Props extends TypographyProps {
  children?: ReactNode;
  truncate?: boolean;
  loading?: boolean;
  formLike?: boolean;
  detailTitle?: boolean;
}

const getTruncateSx = (truncate?: boolean) => {
  return truncate
    ? { whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: 'inherit', overflow: 'hidden', textAlign: 'start' }
    : ({} as any);
};

const getFormLikeSx = (formLike?: boolean) => {
  return formLike ? { bgcolor: 'common.white', borderRadius: '5px', p: '5px', minHeight: '35px' } : ({} as any);
};

const getDetailTitleSx = (detailTitle?: boolean): SxProps => {
  return detailTitle ? { fontSize: '28px', fontWeight: 600, padding: '35px' } : ({} as any);
};

function TypographyComponent(
  { children, truncate, formLike, detailTitle, sx, loading, ...rest }: Props,
  ref: Ref<HTMLSpanElement>,
): ReactElement {
  if (loading) {
    return <Skeleton height={55} width="80%"></Skeleton>;
  }
  return (
    <Typography
      ref={ref}
      {...rest}
      sx={{ ...getTruncateSx(truncate), ...getFormLikeSx(formLike), ...getDetailTitleSx(detailTitle), ...sx }}
    >
      {children}
    </Typography>
  );
}

export default forwardRef<HTMLSpanElement, Props>(TypographyComponent);
